import { useNavigate } from "react-router-dom";
import { ApiService as api } from "../services/ApiService";
import { useSession } from "./useSession";
import { useStates } from "./useStates";
import urls from "../config/urls.json";
import { useState } from "react";
import { isProd } from "../services/env";

export const useAppointmentResponse = () => {
    const navigate = useNavigate();
    const { batchUpdate, getAppointmentPayload, isAppointmentPayloadReady, getAppointmentNewPayload } = useSession();
    const { states, setCurrentState, isCreaAppuntamentoBusy, isCreaAppuntamentoError, isCreaAppuntamentoDone } = useStates();

    const [fetchError, setFetchError] = useState(false);
    const [fetchErrorMessage, setFetchErrorMessage] = useState("");

    const showAppError = () => {
        if (!isProd()) console.log("C'è stato un errore con il tuo appuntamento. <br />Per favore riprova");
        const errorNode = document.createElement("div");
        errorNode.classList.add("text-center");
        errorNode.style.marginTop = "300px";
        errorNode.style.marginBottom = "200px";
        errorNode.innerHTML = "C'è stato un errore con il tuo appuntamento.";
        const overlay = document.querySelector("#start-overlay");
        if (overlay) {
            overlay.replaceWith(errorNode);
        }
    };

    const handleAppointmentSubmission = async () => {
        if (!isAppointmentPayloadReady()) {
            setCurrentState(states.CREA_APPUNTAMENTO_ERROR);
            return;
        }

        setCurrentState(states.CREA_APPUNTAMENTO_START);
        let appuntamentoResult = {};
        try {
            appuntamentoResult = await api.CreateAppointment(
                // getAppointmentPayload()
                getAppointmentNewPayload()
            );
        } catch (error) {
            setCurrentState(states.CREA_APPUNTAMENTO_ERROR);
            setFetchErrorMessage("C'è stato un errore con il tuo appuntamento. <br />Per favore riprova.");
            setFetchError(true);
            showAppError();
            return;
        }

        // @todo gestione errore crea
        // if (!appuntamentoResult.codRes || !["0", "200"].includes(appuntamentoResult.codRes)) {
        if (!appuntamentoResult || appuntamentoResult.resultCode == 2) {
            setCurrentState(states.CREA_APPUNTAMENTO_ERROR);
            setFetchErrorMessage("C'è stato un errore con il tuo appuntamento. <br />Per favore riprova.");
            setFetchError(true);
            showAppError();
            return;
        }

        setCurrentState(states.CREA_APPUNTAMENTO_END);
        batchUpdate({
            oppID: appuntamentoResult.oppID,
            contactID: appuntamentoResult.contactID,
        });

        if (appuntamentoResult.typUrl) {
            window.open(appuntamentoResult.typUrl, "_self");
        } else {
            navigate(urls.riepilogo.path, { replace: true });
        }
    };

    const handleAppointmentBusinessSubmission = async () => {
        if (!isAppointmentPayloadReady()) {
            setCurrentState(states.CREA_APPUNTAMENTO_ERROR);
            return;
        }

        setCurrentState(states.CREA_APPUNTAMENTO_START);
        let appuntamentoResult = {};
        try {
            appuntamentoResult = await api.CreaAppuntamentoBusinessAsync(getAppointmentPayload());
        } catch (error) {
            setCurrentState(states.CREA_APPUNTAMENTO_ERROR);
            setFetchErrorMessage("C'è stato un errore con il tuo appuntamento. <br />Per favore riprova.");
            setFetchError(true);

            showAppError();
            return;
        }

        // @todo gestione errore crea
        if (!appuntamentoResult.hasOwnProperty("Status") || !["1", 1].includes(appuntamentoResult.Status)) {
            /*setCurrentState(states.CREA_APPUNTAMENTO_ERROR);
      setFetchErrorMessage("C'è stato un errore con il tuo appuntamento. <br />Per favore riprova.");
      setFetchError(true);
      showAppError();
      return;*/

            //Non va mai in errore, sarà resilienza a gestire le retry
            appuntamentoResult = {
                status: 1,
                message: "",
                data: {
                    Status: 0,
                    Message: "OK",
                },
            };
        }

        setCurrentState(states.CREA_APPUNTAMENTO_END);
        batchUpdate({
            oppID: appuntamentoResult.oppID,
            contactID: appuntamentoResult.contactID,
        });

        if (appuntamentoResult.typUrl) {
            window.open(appuntamentoResult.typUrl, "_self");
        } else {
            navigate(urls.riepilogoBusiness.path, { replace: true });
        }
    };

    const handleAppointmentC5Submission = async () => {
        if (!isAppointmentPayloadReady()) {
            setCurrentState(states.CREA_APPUNTAMENTO_ERROR);
            return;
        }

        setCurrentState(states.CREA_APPUNTAMENTO_START);
        let appuntamentoResult = {};
        try {
            const payload = getAppointmentPayload();
            appuntamentoResult = await api.CreaAppuntamentoC5Async(payload);
        } catch (error) {
            setCurrentState(states.CREA_APPUNTAMENTO_ERROR);
            setFetchErrorMessage("C'è stato un errore con il tuo appuntamento. <br />Per favore riprova.");
            setFetchError(true);

            showAppError();
            return;
        }

        // @todo gestione errore crea
        if (!appuntamentoResult.hasOwnProperty("Status") || !["0", 0].includes(appuntamentoResult.Status)) {
            /*setCurrentState(states.CREA_APPUNTAMENTO_ERROR);
      setFetchErrorMessage("C'è stato un errore con il tuo appuntamento. <br />Per favore riprova.");
      setFetchError(true);
      showAppError();
      return;*/

            //Non va mai in errore, sarà resilienza a gestire le retry
            appuntamentoResult = {
                status: 1,
                message: "",
                data: {
                    Status: 0,
                    Message: "OK",
                },
            };
        }

        setCurrentState(states.CREA_APPUNTAMENTO_END);
        batchUpdate({
            oppID: appuntamentoResult.oppID,
            contactID: appuntamentoResult.contactID,
        });

        if (appuntamentoResult.typUrl) {
            window.open(appuntamentoResult.typUrl, "_self");
        } else {
            navigate(urls.riepilogoC5.path, { replace: true });
        }
    };

    return {
        handleAppointmentSubmission,
        handleAppointmentBusinessSubmission,
        handleAppointmentC5Submission,
        isCreaAppuntamentoBusy,
        isCreaAppuntamentoError,
        isCreaAppuntamentoDone,
        fetchErrorMessage,
        fetchError,
        setFetchError,
        setFetchErrorMessage,
    };
};
